/* eslint-disable @repo/internal/react/require-jsdoc */

import React, { createContext } from 'react';

export const LevelContext: React.Context<number> = createContext(0);
